import { useBrand } from '@bnnvara/brand';
import { GridItem } from '@bnnvara/grids';
import { formatDate } from '@bnnvara/helpers';
import BaseMetaBlock from '@bnnvara/metablocks';
import { Heading } from '@bnnvara/typography';
import PropTypes from 'prop-types';
import React from 'react';

import { Bookmark } from '../components/Bookmark/button/Bookmark';
import Link from '../components/Link';
import { getBrandSlug } from '../helpers/getBrandSlug';

const formatReadingTime = (minutes) => {
  const notation = minutes === 1 ? 'minuut' : 'minuten';

  return `${minutes} ${notation}`;
};

const ComposableArticleHeader = ({
  title,
  publishDate,
  readingTime,
  categories,
  viewCount,
  article,
}) => {
  const categoryList = categories.map((category, index) => (
    <Link href={`rubrieken/${category.slug}`} key={category.slug}>
      <a>
        {category.name}
        <span key={`comma-${category.name}`}>
          {index < categories.length - 1 ? ', ' : null}
        </span>
      </a>
    </Link>
  ));
  const brand = useBrand();
  const brandSlug = getBrandSlug(brand?.slug);
  const bookmarkedHref = `${brandSlug}/artikelen/${article?.slug}`;

  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      <Heading element="h1" variant="one">
        {title}
      </Heading>
      <BaseMetaBlock
        categories={categoryList}
        publicationDate={formatDate(new Date(publishDate), 'dd-MM-yyyy')}
        duration={`leestijd ${formatReadingTime(readingTime)}`}
        viewCount={viewCount ? parseInt(viewCount, 10) : 0}
      >
        <Bookmark
          content={{
            id: article?.id,
            title: article?.title,
            type: 'article',
            publishDate: article?.publishDate,
            href: bookmarkedHref,
            image: {
              url: article?.thumbnail?.url,
              altText: article?.title,
            },
          }}
        />
      </BaseMetaBlock>
    </GridItem>
  );
};

ComposableArticleHeader.defaultProps = {
  categories: [],
};

ComposableArticleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  readingTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  viewCount: PropTypes.string,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ),
  article: PropTypes.shape(),
};

export default ComposableArticleHeader;
